import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/core/core.module';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextarea } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PublicCaseInfoComponent } from './info/info.component';
import { PublicCaseInfoRoutingModule } from './public-case-info-routing.module';
import { TableModule } from 'primeng/table';
import { FileUploadModule } from 'primeng/fileupload';
import { GoogleMapsModule } from '@angular/google-maps';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';

@NgModule({
    declarations: [
        PublicCaseInfoComponent
    ],
    imports: [
        CoreModule,
        CommonModule,
        FormsModule,
        PublicCaseInfoRoutingModule,
        CardModule,
        ButtonModule,
        SelectButtonModule,
        InputTextarea,
        RadioButtonModule,
        TableModule,
        ButtonModule,
        ReactiveFormsModule,
        FileUploadModule,
        GoogleMapsModule,
        AccordionModule,
        PanelModule,
        MessagesModule,
        MessageModule
    ]
})
export class PublicCaseInfoModule { }
